import req from '../util/request'
import config from '../config'

export default {
  /**
   * 添加基本信息，第一表单
   * @see https://yapi.geekbang.org/project/71/interface/api/6492
   * @param {object} data 基本信息
   */
  createInfo (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/createinfo`,
      data
    })
  },

  /**
   * 用户注册接口，合并基本信息和详细信息
   * @param {object} data 完整用户信息
   */
  userRegister (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/register`,
      data
    })
  },

  /**
   * 获取用户配置信息（合并版本）
   * @returns {object} 合并后的表单配置数据
   */
  getUserProfile () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/profile`
    })
  },

  /**
   * 添加学历等信息，第二表单
   * @see https://yapi.geekbang.org/project/71/interface/api/6494
   * @param {obejct} info 不为空
   * @param {object} state 可为空
   */
  createdDetail (info, state) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/savedetail`,
      data: Object.assign({}, info, state)
    })
  },

  /**
   * 更新基本信息
   * @param {object} data
   * @returns
   */
  updateInfo (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/updateinfo`,
      data
    })
  },

  /**
   * 获取用户信息【第一表单】
   * @see https://yapi.geekbang.org/project/71/interface/api/22247
   * @returns
   */
  getUserInfo () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/info`
    })
  },

  /**
   * 获取用户信息【第二表单】
   * @see https://yapi.geekbang.org/project/71/interface/api/6494
   * @returns
   */
  getUserDetails () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/details`
    })
  },

  /**
   * 获取所有分会
   * @returns
   */
  getBranchesAll () {
    return req({
      url: `${config.tgoServer}/serv/tgo/common/branch-all`
    })
  },

  /**
   * 获取某个关键词下所有相关的领域标签，模糊查询
   * @param {object} data
   * @param {string} data.name 标签内容
   * @returns
   */
  getTags (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/common/tags-all`,
      data
    })
  },

  // TODO 请求地址
  /**
   * 获取某个关键词下所有推荐人，模糊查询
   * @param {object} data
   * @param {string} data.name 标签内容
   * @returns
 */
  getReferer (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/check-referrer`,
      data
    })
  },

  /**
   * 检查手机是否存在
   * @param {*} phone 手机号
   * @param {*} country 区号
   * @returns
   */
  checkPhoneIsExist (phone, country) {
    return req({
      url: `${config.tgoServer}/serv/tgo/common/phone-exist`,
      data: {
        phone,
        area_code: country
      }
    })
  },

  /**
   * 上传头像
   * @param {*} type
   * @param {*} avatar
   * @returns
   */
  uploadAvatar (type, avatar) {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/avatar`,
      data: {
        type, avatar
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  /**
   * 获取用户状态信息
   * @returns
   */
  getUserStatus () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/userstatus`
    })
  },

  // 重新提交审核
  reAudit () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/audit`
    })
  },

  /**
   * 获取热门活动
   * @returns
   */
  getHotEvent () {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/hot-events`
    })
  },

  /**
   * 获取日历活动
   * @param {object} data
   * @returns
   */
  getCalendarEvent (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/calendar`,
      data
    })
  },

  // 获取活动类型
  getEventTypes (headers = {}) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/types`,
      headers
    })
  },

  /**
   * 获取活动列表
   * @see https://yapi.geekbang.org/project/71/interface/api/935
   * @param {object} data
   * @returns
   */
  getEventList (data = {}, headers = {}) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/get-list`,
      data,
      headers
    })
  },

  /**
   * 获取活动详情
   * @param {object} data
   * @param {number} data.event_id 活动id
   */
  getEventDetail (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/detail`,
      data
    })
  },

  /**
   * TGO 【活动】【小程序】活动签到
   * @see https://yapi.geekbang.org/project/71/interface/api/22106
   */
  getActivitySignin (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/sign-in`,
      data
    })
  },

  // 获取学员信息【精简版】
  getTeamUserInfo () {
    return req({
      url: `${config.tgoServer}/serv/tgo/team/user`
    })
  },

  /**
   * TGO【活动】个人参与活动信息
   * @see https://yapi.geekbang.org/project/71/interface/api/22341
   * @param {object} data
   * @param {number} data.event_id 活动id
   */
  getUserActivityStatus (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/get-events-user`,
      data
    })
  },

  /**
   * TGO 【活动】【小程序】活动加入
   * @see https://yapi.geekbang.org/project/71/interface/api/22153
   * @param {object} data
   * @param {number} data.event_id 活动id
   */
  signupActivity (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/sign-up`,
      data
    })
  },

  /**
   * TGO 【活动】【小程序】取消报名
   * @see https://yapi.geekbang.org/project/71/interface/api/22343
   * @param {object} data
   * @param {number} data.event_id 活动id
   */
  cancelSignupActivity (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/cancel-signup`,
      data
    })
  },

  /**
   * TGO 【活动】【小程序】活动签到码
   * @param {object} data
   * @param {number} data.event_id 活动id
   * @see https://yapi.geekbang.org/project/71/interface/api/22105
   */
  getActivitySignCode (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/sign-code`,
      data
    })
  },

  /**
   * 公告与动态
   */
  getNoticeList (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/notice/list`,
      data
    })
  },

  /**
   * 获取最新的动态
   */
  getNoticeNews () {
    return req({
      url: `${config.tgoServer}/serv/tgo/notice/news`
    })
  },

  /**
   * 获取单条动态详情
   */
  getNoticeSingleNews (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/notice/read`,
      data
    })
  },

  /**
   * 获取董事会成员
   */
  getBranchInfo () {
    return req({
      url: `${config.tgoServer}/serv/tgo/branch/list`
    })
  },

  /**
   * 获取选中条件的学员信息
   * @param {object} data
   */
  getConditionMemberInfo (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/member/list`,
      data
    })
  },

  /**
   * 获取我的小组列表
   * @see https://yapi.geekbang.org/project/71/interface/api/1217
   * @returns {Object}    res               返回数据
   * @returns {Number}    res.team_id       组ID
   * @returns {String}    res.team_name     组名称
   * @returns {Number}    res.user_id       用户ID
   */
  getGroupList () {
    return req({
      url: `${config.tgoServer}/serv/tgo/user/user-team`
    })
  },

  /**
   * 获取小组成员信息
   * @see https://yapi.geekbang.org/project/71/interface/api/1213
   * @returns {Object}    res                              返回数据
   * @returns {Object}    res.list                         成员信息
   * @returns {Number}    res.list.user_id                 成员ID
   * @returns {String}    res.list.name                    姓名
   * @returns {String}    res.list.half_length_portrait    半身像
   * @returns {String}    res.list.job_title               职位
   * @returns {String}    res.list.company                 公司
   * @returns {Number}    res.list.leader                  0:不是组长，1:是组长
   * @returns {Number}    res.type                         1官方小组2兴趣小区
   * @returns {String}    res.team_name                    小组名称
   */
  getGroupInfo (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/team/info`,
      data
    })
  },

  /**
   * 获取小组活动
   * @see https://yapi.geekbang.org/project/71/interface/api/22223
   * @returns {Object}    res                              返回数据
   * @returns {Object}    res.list                         成员信息
   * @returns {Object}    res.page                         分页信息
   * @returns {Number}    res.page.total                   多少数据
   * @returns {String}    res.page.pages                   多少页
   */
  getGroupActivity (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/get-list-teamid`,
      data
    })
  },

  /**
   * 获取我的活动
   * @see https://yapi.geekbang.org/project/71/interface/api/22136
   * @returns {Object}    res                     返回数据
   * @returns {Object}    res.list                活动信息
   * @returns {Number}    res.list.user_id        用户id
   * @returns {Number}    res.list.creater        0参与 1创建
   * @returns {Number}    res.page                分页信息
   * @returns {Number}    res.page.total          多少数据
   * @returns {Number}    res.page.pages          多少页
   */
  getMyActivity (data) {
    return req({
      url: `${config.tgoServer}/serv/tgo/events/my-events`,
      data
    })
  }
}
